import { useCallback } from "react"

import { login } from "@/services"
import Toast from "@/topic/rogue_4/components/Toast"
import { auth } from "@/utils/auth"

export const useLogin = () => {
    const handleLogin = useCallback(async (token: string) => {
        auth.setToken(token)

        const { code, msg } = await login(token)

        if (code !== 0) {
            Toast.message({ content: msg })
        }

        return { code, msg }
    }, [])

    return handleLogin
}
